export default __webpack_public_path__ + "static/media/home.17adeb2d.webp";